// Thème clair / sombre posé en `data-theme` sur body (handoff). Choix gardé dans le navigateur ;
// « Système » suit `prefers-color-scheme`.
import { useEffect, useState } from 'react';

export type ThemeChoice = 'system' | 'light' | 'dark';

const KEY = 'crenow.theme';
const PAPER = { light: '#F3F0E8', dark: '#121612' };
const media = () => window.matchMedia('(prefers-color-scheme: dark)');

function readChoice(): ThemeChoice {
  try {
    const value = localStorage.getItem(KEY);
    return value === 'light' || value === 'dark' ? value : 'system';
  } catch {
    return 'system';
  }
}

function apply(choice: ThemeChoice) {
  const theme = choice === 'system' ? (media().matches ? 'dark' : 'light') : choice;
  document.body.dataset.theme = theme;
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', PAPER[theme]);
}

/** À appeler une fois au démarrage, avant le premier rendu (pas de flash de thème). */
export function initTheme() {
  apply(readChoice());
  media().addEventListener('change', () => {
    if (readChoice() === 'system') apply('system');
  });
}

export function useTheme(): [ThemeChoice, (choice: ThemeChoice) => void] {
  const [choice, setChoice] = useState<ThemeChoice>(readChoice);
  useEffect(() => apply(choice), [choice]);
  return [
    choice,
    (next) => {
      try {
        if (next === 'system') localStorage.removeItem(KEY);
        else localStorage.setItem(KEY, next);
      } catch {
        // Stockage indisponible (navigation privée) : thème appliqué pour la session seulement.
      }
      setChoice(next);
    },
  ];
}
